(() => {
  class DeviKariSizeGuide {
    constructor() {
      this.modal = document.querySelector('[data-size-guide-modal]');
      if (!this.modal) return;

      this.csvUrl = this.modal.dataset.csvUrl;
      this.titleEl = this.modal.querySelector('[data-size-guide-product-title]');
      this.tableContainer = this.modal.querySelector('[data-size-guide-table-container]');
      this.triggers = document.querySelectorAll('[data-size-guide-trigger]');

      this.bind();
    }

    bind() {
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-size-guide-trigger]');
        if (trigger) {
          event.preventDefault();
          this.open(trigger.dataset.productHandle);
          return;
        }

        const closeBtn = event.target.closest('[data-close-modal]');
        if (closeBtn && this.modal.classList.contains('is-open')) {
          event.preventDefault();
          this.close();
        }
      });

      // Escape key to close modal
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.modal.classList.contains('is-open')) {
          this.close();
        }
      });
    }

    async open(handle) {
      if (!handle) return;

      // Update product title
      const mainTitle = document.querySelector('.product__title h1')?.textContent?.trim();
      if (this.titleEl) {
        this.titleEl.textContent = mainTitle ? `${mainTitle} Size Chart` : 'Size Chart';
      }

      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dk-modal-is-open');

      if (this.tableContainer) {
        this.tableContainer.innerHTML = '<p class="dk-size-guide__loading">Loading measurements...</p>';
      }

      try {
        const sizeData = await this.loadSizeData(handle);
        this.renderTable(sizeData);
      } catch (error) {
        console.error('Error loading size chart:', error);
        this.renderFallbackTable();
      }
    }

    close() {
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dk-modal-is-open');
    }

    async loadSizeData(handle) {
      if (window.dkSizeGuidesCache) {
        return this.filterByHandle(window.dkSizeGuidesCache, handle);
      }

      if (!this.csvUrl) throw new Error('No CSV URL provided');

      const response = await fetch(this.csvUrl);
      if (!response.ok) throw new Error('Failed to fetch size guide CSV');

      const text = await response.text();
      const allRows = this.parseCSV(text);
      window.dkSizeGuidesCache = allRows;

      return this.filterByHandle(allRows, handle);
    }

    parseCSV(text) {
      const lines = text.split('\n').map(line => line.trim()).filter(line => line.length > 0);
      if (lines.length === 0) return [];
      const headers = lines[0].split(',').map(h => h.trim());
      const rows = [];
      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(',').map(v => v.trim());
        if (values.length === headers.length) {
          const row = {};
          headers.forEach((header, index) => {
            row[header] = values[index];
          });
          rows.push(row);
        }
      }
      return rows;
    }

    filterByHandle(rows, handle) {
      return rows.filter(row => row.handle === handle);
    }

    renderTable(rows) {
      if (!rows || rows.length === 0) {
        this.renderFallbackTable();
        return;
      }

      // Headers should be size, bust, waist, hips, length
      const keys = ['size', 'bust', 'waist', 'hips', 'length'];
      const headersMarkup = keys.map(key => `<th>${key.toUpperCase()}</th>`).join('');

      const rowsMarkup = rows.map(row => {
        const cols = keys.map(key => `<td>${this.escapeHtml(row[key] || '-')}</td>`).join('');
        return `<tr>${cols}</tr>`;
      }).join('');

      if (this.tableContainer) {
        this.tableContainer.innerHTML = `
          <table class="dk-size-guide__table">
            <thead>
              <tr>${headersMarkup}</tr>
            </thead>
            <tbody>
              ${rowsMarkup}
            </tbody>
          </table>
        `;
      }
    }

    renderFallbackTable() {
      // Default standard size guide fallback if handle not matched or error
      const defaultRows = [
        { size: 'S', bust: '36', waist: '32', hips: '40', length: '42' },
        { size: 'M', bust: '38', waist: '34', hips: '42', length: '42' },
        { size: 'L', bust: '40', waist: '36', hips: '44', length: '43' },
        { size: 'XL', bust: '42', waist: '38', hips: '46', length: '43' },
        { size: 'XXL', bust: '44', waist: '40', hips: '48', length: '44' }
      ];
      this.renderTable(defaultRows);
    }

    escapeHtml(value) {
      return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    window.DeviKariSizeGuide = new DeviKariSizeGuide();
  });
})();
